(() => {
  let config = {};
  try { config = JSON.parse(document.getElementById('bhb-config')?.textContent || '{}'); } catch {}
  const previewLinks = root => {
    if (!config.previewRoutes && !config.previewNewPages) return;
    const newPages = { '/pages/box-samenstellen': 'box-samenstellen', '/pages/verzending': 'bhb-verzending', '/pages/veelgestelde-vragen': 'bhb-veelgestelde-vragen', '/pages/onze-materialen': 'bhb-onze-materialen' };
    const anchors = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
    for (const anchor of anchors) {
      const url = new URL(anchor.getAttribute('href'), window.location.href);
      if (![window.location.hostname, 'buildinghealthybodies.shop', '51j1a5-0q.myshopify.com'].includes(url.hostname)) continue;
      const match = url.pathname.match(/\/products\/([^/]+)$/);
      const view = config.previewRoutes && match && config.productViews?.[decodeURIComponent(match[1])];
      if (view && !url.searchParams.has('view')) { url.searchParams.set('view', view); anchor.href = url.pathname + url.search + url.hash; }
      const pageView = config.previewNewPages && newPages[url.pathname];
      if (pageView) { url.pathname = '/pages/collection-bundle'; url.searchParams.set('view', pageView); anchor.href = url.pathname + url.search + url.hash; }
    }
  };
  previewLinks(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') previewLinks(record.target);
    else record.addedNodes.forEach(node => { if (node.nodeType === 1) previewLinks(node); });
  })).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  const openers = new WeakMap();
  const close = dialog => { if (dialog?.open) dialog.close(); };
  document.addEventListener('click', event => {
    const menu = event.target.closest('[data-bhb-menu]');
    if (menu) {
      const expanded = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(expanded));
      document.getElementById(menu.getAttribute('aria-controls'))?.classList.toggle('is-open', expanded);
    }
    const opener = event.target.closest('[data-bhb-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.bhbDialog);
      if (dialog instanceof HTMLDialogElement && !dialog.open) { openers.set(dialog, opener); dialog.showModal(); }
    }
    const closer = event.target.closest('[data-bhb-dialog-close]');
    if (closer) close(closer.closest('dialog'));
    const thumbnail = event.target.closest('[data-bhb-image]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-bhb-gallery]');
      const image = gallery?.querySelector('[data-bhb-gallery-main]');
      if (image) { image.src = thumbnail.dataset.bhbImage; image.removeAttribute('srcset'); image.alt = thumbnail.dataset.bhbAlt || image.alt; }
      gallery?.querySelectorAll('[data-bhb-image]').forEach(button => { const selected = button === thumbnail; button.setAttribute('aria-pressed', String(selected)); button.classList.toggle('active', selected); });
    }
    const dialog = event.target;
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog);
    }
  });
  document.addEventListener('close', event => { const opener = openers.get(event.target); if (opener?.isConnected) opener.focus(); }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-bhb-menu][aria-expanded="true"]').forEach(button => { button.setAttribute('aria-expanded', 'false'); document.getElementById(button.getAttribute('aria-controls'))?.classList.remove('is-open'); button.focus(); });
  });
})();
